import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { MenuService } from '../menu/menu.service';
import { AuthService } from './auth.service';
import { PermissionService } from './permission.service';

/**
 * Protege as rotas do shell: exige sessão Cognito válida. Sem sessão, redireciona
 * para /login guardando a URL de retorno. Com sessão, pré-carrega as permissões
 * granulares (`module:action`) E o menu data-driven (`/me/menu`) antes de o shell
 * montar, para que itens e telas já apareçam de acordo com o catálogo e os grants.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const permissions = inject(PermissionService);
  const menu = inject(MenuService);
  const router = inject(Router);

  if (await auth.isAuthenticated()) {
    await auth.refreshUser();
    await Promise.all([permissions.ensureLoaded(), menu.ensureLoaded()]);
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
